module.exports = __webpack_public_path__ + "static/media/zoomy5.2268896b.jpg";